import { CASINO_MULTIVIEW_ENABLED_QUERY_VALUE } from 'utils/constants/casino/url-queries';
import { SingleviewModeChecker } from 'newelements/Casino/GameSingleViewRenderer/__partials/GameViewContainer/__partials/SingleviewModeChecker';
import { useSearchParams } from 'hooks/useSearchParams';

export const SingleviewOuterManager = () => {
  const { multiview } = useSearchParams();

  if (multiview === CASINO_MULTIVIEW_ENABLED_QUERY_VALUE) {
    return null;
  }

  return <SingleviewModeChecker />;
};
